import { render, staticRenderFns } from "./addEditCurrency.vue?vue&type=template&id=6487a788"
import script from "./addEditCurrency.vue?vue&type=script&lang=js"
export * from "./addEditCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports